import { Header } from "../../component/Header";
import { useTranslation } from "react-i18next";
import { ReactComponent as Check } from "../../rsc/check.svg";
import { colorPrimaryDark } from "../../rsc/colors";
import { ReactComponent as PempemLogo } from "../../rsc/pempem_logo.svg";
import { ContactToSellMyFruitV3 } from "./ContactToSellMyFruitV3";
import { useEffect } from "react";
import { Footer } from "../../component/Footer";

export function MainPageV3() {

    const { t } = useTranslation();

    useEffect(() => {
        window.gtag("event", "page_view", { page_path: 'landingpage3' });
        // eslint-disable-next-line
    }, [])

    return (
        <div style={{ width: "100%", height: "100%" }}>
            <div style={{ minHeight: "100%", display: "flex", flexDirection: "column" }}>
                <Header />
                <div style={{ flex: 1 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginTop: "10px", fontWeight: "700", padding: "10px 20px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                            <Check />
                            <p className="text-medium" style={{ padding: 0, margin: 0, color: "#079AA8" }}>{t('transport_included')}</p>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                            <Check />
                            <p className="text-medium" style={{ padding: 0, margin: 0, color: "#079AA8" }}>{t('no_grading_at_farm')}</p>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                            <Check />
                            <p className="text-medium" style={{ padding: 0, margin: 0, color: "#079AA8" }}>{t('digital_scale')}</p>
                        </div>
                    </div>
                    <div style={{ display: "flex", gap: "10px", justifyContent: "center", margin: "10px", alignItems: "center" }}>
                        <p className="text-huge" style={{ fontWeight: "800", color: colorPrimaryDark }}>{t('sell_my_fruit')} {t('to')}</p>
                        <PempemLogo style={{ width: '140px', height: "42px" }} fill={colorPrimaryDark} />
                    </div>

                    <ContactToSellMyFruitV3 style={{}} />
                </div>
            </div>
            <Footer />
        </div>
    )
}